import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
//import logger from 'redux-logger'
import picReducer from './reducers/pics'
import notifReducer from './reducers/notifs'

const reducer = combineReducers({
    picReducer,
    notifReducer
})

const store = createStore(reducer, applyMiddleware(thunk))

export default store